export default __webpack_public_path__ + "static/media/kanipakamHistoryOne.0af2f2d2.png";